module.exports = "<hybse-admin-adduser [userType]=\"'DemoIssuer'\"></hybse-admin-adduser>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-issuers/add-issuer/add-issuer.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-issuers/add-issuer/add-issuer.component.html
// module chunks = main